import type * as schemas from "@common/schemas/v2";
import * as models from "@common/models/v2";
import { BaseStep } from "./base";
import { StepActions } from "./step";
import { FlowFlexibility } from "@common/schemas";

export class ShowContentStep extends BaseStep {
  attributes: models.ShowContentStepAttributes;
  actions: StepActions;

  constructor(step: schemas.Step, actions: StepActions, flowFlexibility: FlowFlexibility) {
    super(step, actions, flowFlexibility);
    this.attributes = new models.ShowContentStepAttributes(step.attributes as schemas.ShowContentStepAttributes);
    this.actions = actions;
  }

  get additionalContent() {
    return this.attributes.content;
  }
}
